import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { Tooltip, Button, Modal, Divider, message } from "antd";
import { QuestionCircleOutlined, CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { format, findDeep, getSolutionDetail } from "@/utils";
import api from "@/api";
import { publicPath } from "@/utils/base";

const { confirm } = Modal;
import dataJson from "@/../public/data.json";

const prefix = "mySolutionDetail-info";
import "./index.less";

function Info() {
  const { my_solution_detail, confirmText, cancelText, release, delete_text } = dataJson;

  const [solutionMapping, setSolutionMapping] = useState<any>();

  const navigate = useNavigate();
  const { id } = useParams();

  const solutionDetail = useSelector((state: any) => state.solutionDetail);

  const handleDelete = () => {
    confirm({
      title: delete_text + my_solution_detail?.detail_title,
      icon: null,
      width: 328,
      centered: true,
      closable: true,
      closeIcon: <CloseOutlined />,
      okText: confirmText,
      cancelText: cancelText,
      content: (
        <div className="delete-modal-content">
          {my_solution_detail.app_delete_content1}&quot;{solutionMapping?.name}&quot;
          {my_solution_detail.app_delete_content2}
        </div>
      ),
      onOk: async () => {
        try {
          const res: any = await api.deleteSolution({ id });

          if (res?.code == 200) {
            navigate(`${publicPath}/my_solution`);
          } else {
            message.error(res.msg);
          }
        } catch (errorInfo: any) {
          console.error(errorInfo);
        }
      },
    });
  };

  useEffect(() => {
    if (solutionDetail) {
      const firstTwo = solutionDetail.versions.slice(0, 2);
      const isDel = firstTwo.every((item: any) => {
        const resShowMode = findDeep(release.show_mode_arr, item.showMode);
        return resShowMode?.baseBtns?.includes("delete");
      });

      const resDataCopy = {
        ...solutionDetail,
        createTimeText: format(new Date(Number(solutionDetail?.createTime)), "yyyy年MM月dd日 HH:mm:ss"),
        isDel,
      };

      setSolutionMapping(resDataCopy);
    }
  }, [solutionDetail]);

  return (
    <div className={prefix}>
      <div className={`${prefix}-inner`}>
        <div className={`${prefix}-header`}>
          <div className={`${prefix}-header-text`}>
            <div className={`${prefix}-header-title`}>{my_solution_detail.detail_title_text}</div>
            <div className={`${prefix}-header-tip`}>{my_solution_detail.info_tip}</div>
          </div>
          <div className={`${prefix}-header-btns`}>
            <Button className={`${prefix}-content-delete`} disabled={!solutionMapping?.isDel} onClick={handleDelete}>
              {delete_text + my_solution_detail?.detail_title}
            </Button>
          </div>
        </div>
        <div className={`${prefix}-content`}>
          <div className={`${prefix}-content-title`}>{my_solution_detail.developer_title}</div>
          <div className={`${prefix}-content-developer`}>
            <Tooltip
              placement="bottomLeft"
              title={my_solution_detail.developer_tip}
              overlayClassName={`${prefix}-content-developer-tooltip`}
              color="#fff"
              overlayInnerStyle={{
                color: "rgba(0,0,0,0.8)",
                width: 200,
                padding: "10px 16px",
                transform: "translate(-12px, 0)",
              }}
            >
              <QuestionCircleOutlined style={{ color: "#0A59F7", cursor: "pointer", fontSize: 14 }} />
            </Tooltip>
            <div className={`${prefix}-content-developer-id`}>
              <span>{my_solution_detail.developer_ID}</span>
              {solutionMapping?.developerId}
            </div>
          </div>
          <Divider />
          <div className={`${prefix}-content-title mt-title`}>{my_solution_detail.detail_title}</div>
          <div className={`${prefix}-content-value`}>
            <span>{my_solution_detail.solution_ID}</span>
            {solutionMapping?.id}
          </div>
          <div className={`${prefix}-content-value`}>
            <span>{my_solution_detail.create_time}</span>
            {solutionMapping?.createTimeText}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Info;
